import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { RIO_GRANDE_DO_SUL, estadosList } from "@/models/Estados";
import { mapaApi } from "@/api/MapaApi";

export class MapasService {
  public async obterEnderecos(endereco: string): Promise<LocalidadeModel[]> {
    const localidadeMapaDTO = await mapaApi.obterEnderecos(endereco);

    const enderecos = localidadeMapaDTO.map((l) => {
      const localidade = new LocalidadeModel();
      localidade.logradouro = l.rua;
      localidade.numero = l.numero || "";
      localidade.complemento = "";
      localidade.bairro = l.bairro || "";
      localidade.cidade = l.cidade || "";
      localidade.cep = l.cep || "";
      localidade.estado =
        estadosList.find((e) => e.nome == l.estado) || RIO_GRANDE_DO_SUL;
      localidade.geoPosicao = {
        latitude: l.latitude,
        longitude: l.longitude,
      };
      localidade.informarEnderecoManual = false;
      return localidade;
    });
    return enderecos;
  }

  async obterEnderecoPorCep(cep: string): Promise<LocalidadeModel> {
    const localidadeMapaDTO = await mapaApi.obterEnderecoPorCep(cep);

    return new Promise((resolve, reject) => {
      if (localidadeMapaDTO) {
        const localidade = new LocalidadeModel();
        localidade.logradouro = localidadeMapaDTO.rua;
        localidade.bairro = localidadeMapaDTO.bairro;
        localidade.cidade = localidadeMapaDTO.cidade;
        localidade.estado = estadosList.find(
          (e) => e.sigla == localidadeMapaDTO.estado
        );

        resolve(localidade);
      } else {
        reject("Nenhum endereço foi encontrado");
      }
    });
  }

  async obterGeoLocalizacao(cep: string): Promise<LocalidadeModel> {
    const localidadeMapaDTO = await mapaApi.obterGeoLocalizacao(cep);

    return new Promise((resolve, reject) => {
      if (localidadeMapaDTO) {
        const localidade = new LocalidadeModel();
        localidade.geoPosicao = {
          latitude: localidadeMapaDTO.latitude,
          longitude: localidadeMapaDTO.longitude,
        };

        resolve(localidade);
      } else {
        reject("Nenhuma geolocalizacao foi encontrada");
      }
    });
  }

}

export const mapasService = new MapasService();
